import module from 'clientes/module.js'
import template from './template.html'

const catalogo = [{ id: 'F', descripcion: 'Física' }, { id: 'M', descripcion: 'Moral' }]

export class ClientesAgregarComponent {
  data = {
    rfc: '',
    nombre: '',
    apellido_paterno: '',
    apellido_materno: '',
    id_regimen_fiscal: '',
  }
  catalogo = catalogo
  agregando = false

  constructor(ClientesService, EmpresasCatalogoRegimenFiscal, $state) {
    this.ClientesService = ClientesService
    this.EmpresasCatalogoRegimenFiscalService = EmpresasCatalogoRegimenFiscal
    this.$state = $state
  }

  $onInit () {
    this.promise = this.EmpresasCatalogoRegimenFiscalService.get()
      .then((response) => (this.regimenFiscal = response.data, this.regimenCopia = this.regimenFiscal))
  }

  filtarRegimen (rfc) {
    this.data.id_regimen_fiscal = undefined
    this.regimenFiscal = rfc.length === 12 ? this.regimenCopia.filter(item => item.moral) : this.regimenCopia.filter(item => item.fisica)
  }

  verificar () {
    if (this.data.tipo_persona === 'M') {
      this.data.apellido_materno = ''
      this.data.apellido_paterno = ''
    }
  }

  agregar () {
    if (this.agregando) return

    this.error = null

    this.ClientesService.post(this.data)
      .then(() => (this.$state.go('clientes.buscar')))
      .catch((error) => (this.error = error.data))
      .finally(() => this.agregando = false)
  }
}

module.component('clientesAgregar', {
  controller: ClientesAgregarComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/clientes/components/agregar/component.js